import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './multifile-upload.module.scss';
import { getPreview } from '../library/constants';
import { Button } from 'antd';
import { showAlert } from '../components/message/alert.jsx';


const PDFUpload = forwardRef(function PDFUpload(_, ref) {
    const [, setFiles] = useState([])

    useEffect(() => {
        if (!ref.current) {
            ref.current = []
        }
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => ref.current.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        multiple: false,
        maxSize: 10 * 1024 * 1024,
        maxFiles: 1,
        accept: {
            'application/pdf': ['.pdf'],
        },
        onDropRejected: rejections => {
            showAlert(rejections.map(({ errors }) => errors.map(({ message }) => message)).join("\n"))
        },
        onDrop: acceptedFiles => {
            // Clear existing files before adding the new one
            setFiles([]);
            ref.current = [];
            acceptedFiles.forEach(file => {
                addFile(file);
            });
        }
    })

    const addFile = (file) => {
        setFiles(files => {
            return [...files, Object.assign(file, {
                preview: URL.createObjectURL(file)
            })]
        })
        ref.current.push(file)
    }

    const deleteFile = (fileToDelete) => {
        setFiles(files => files.filter(file => file !== fileToDelete));
        ref.current = ref.current.filter(file => file !== fileToDelete);
        URL.revokeObjectURL(fileToDelete.preview); // Clean up the preview URL
    }

    return (
        <>
            <div {...getRootProps({ className: styles.dropArea })}>
                <div className={styles.dropIcon}>
                    <img src="/icons/upload-drop.svg" />
                </div>
                <div className={styles.dropText}>
                    Drag and drop your file
                </div>
                <p>------------ OR ------------</p>
                <input className="input-zone" {...getInputProps()} />
                <div className={styles.browse}>Browse your file</div>
            </div>
            <div className={styles.files}>
                {ref.current.length > 0 && (
                    ref.current.map(file => (
                        <div className={styles.file} key={file.name}>
                            <div>
                                <img
                                    src={getPreview(file)}
                                    // Revoke data uri after image is loaded
                                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                                />
                                <p className="label">{file.name}</p>
                            </div><br />
                            <Button
                                type="primary"
                                danger
                                onClick={() => deleteFile(file)}
                            >
                                Delete
                            </Button>
                        </div>
                    ))
                )}
            </div>
        </>
    )
})

PDFUpload.propTypes = {
    inputName: PropTypes.string,
}

export default PDFUpload